export default "__VITE_ASSET__CL1$W0f4__"